import type { canvClass } from "./canv";

/**
 * @type {canvClass}
 */
export let canv: canvClass;

export function setCanv(ob: canvClass) {
    canv = ob;
}
